import { Client } from 'types/client';

export const prepareClientPayload = (data: Client): Client => {
  const withoutEmptyFields = Object.entries(data).reduce(
    (payload, [key, value]) => {
      if (value) return { ...payload, [key]: value };

      return payload;
    },
    {} as Client,
  );

  return {
    ...withoutEmptyFields,
    ...(withoutEmptyFields.city_id && {
      city_id: Number(withoutEmptyFields.city_id),
    }),
    ...(withoutEmptyFields.state_id && {
      state_id: Number(withoutEmptyFields.state_id),
    }),
  };
};
